import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  config: null,
  isLoading: false,
  error: null,
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setConfigLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setConfigError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setConfig, setConfigLoading, setConfigError } = configSlice.actions;

export default configSlice.reducer;
